import Layout from '@/layout'
import ParentView from '@/components/ParentView'
const asyncFinancialManagementRoutes =
{
  path: '/oa/financialManagement',
  component: Layout,
  redirect: 'noredirect',
  name: '财务管理',
  funcPerms: 'oa:finance',
  alwaysShow: true,
  meta: {
    title: '财务管理',
    icon: 'pay',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'financialManagement/payslip/index',
      component: () => import('@/views/oa/financialManagement/payslip/index.vue'),
      funcPerms: 'oa:finance:payslip',
      name: 'payslip',
      meta: {
        title: '上传工资条',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/payslip/personIndex',
      component: () => import('@/views/oa/financialManagement/payslip/personIndex.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'payslipPerson',
      meta: {
        title: '查看工资条',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/statistics/index',
      component: () => import('@/views/oa/financialManagement/statistics/index.vue'),
      funcPerms: 'oa:finance:statistics',
      name: 'statistics',
      meta: {
        title: '工资统计',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // 资金管理
    {
      path: 'financialManagement/fundManagement/index',
      component: () => import('@/views/oa/financialManagement/fundManagement/index.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'fundManagement',
      meta: {
        title: '资金管理',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/fundManagement/add',
      component: () => import('@/views/oa/financialManagement/fundManagement/add.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'fundManagementAdd',
      hidden: true,
      meta: {
        title: '资金管理新增',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/fundManagement/eit',
      component: () => import('@/views/oa/financialManagement/fundManagement/add.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'fundManagementEdit',
      hidden: true,
      meta: {
        title: '资金管理编辑',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/fundManagement/useOfFund',
      component: () => import('@/views/oa/financialManagement/fundManagement/useOfFund.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'useOfFund',
      hidden: true,
      meta: {
        title: '资金使用',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/fundManagement/billDetail',
      component: () => import('@/views/oa/financialManagement/fundManagement/billDetail.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'billDetail',
      hidden: true,
      meta: {
        title: '账单明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/fundManagement/comment',
      component: () => import('@/views/oa/financialManagement/fundManagement/comment.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'comment',
      hidden: true,
      meta: {
        title: '评论',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // 资金使用管理
    {
      path: 'financialManagement/fundUseManagement/index',
      component: () => import('@/views/oa/financialManagement/fundUseManagement/index.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'fundUseManagement',
      meta: {
        title: '资金使用管理',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/fundUseManagement/fundUse',
      component: () => import('@/views/oa/financialManagement/fundUseManagement/fundUse.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'funduse',
      hidden: true,
      meta: {
        title: '资金使用',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/fundUseManagement/billInfo',
      component: () => import('@/views/oa/financialManagement/fundUseManagement/billInfo.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'billInfo',
      hidden: true,
      meta: {
        title: '账单明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/fundUseManagement/use',
      component: () => import('@/views/oa/financialManagement/fundUseManagement/use.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'use',
      hidden: true,
      meta: {
        title: '使用',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/fundUseManagement/observe',
      component: () => import('@/views/oa/financialManagement/fundUseManagement/observe.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'observe',
      hidden: true,
      meta: {
        title: '评论',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // 科室使用
    {
      path: 'financialManagement/fundUse_dept/index',
      component: () => import('@/views/oa/financialManagement/fundUse_dept/index.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'fundUse_dept',
      meta: {
        title: '资金使用',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/fundUse_dept/billInfo_dept',
      component: () => import('@/views/oa/financialManagement/fundUse_dept/billInfo_dept.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'deptBillInfo',
      hidden: true,
      meta: {
        title: '账单明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'financialManagement/fundUse_dept/observe_dept',
      component: () => import('@/views/oa/financialManagement/fundUse_dept/observe_dept.vue'),
      funcPerms: 'oa:finance:viewPayslip',
      name: 'deptObserve',
      hidden: true,
      meta: {
        title: '评论',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }
  ]
}
export default asyncFinancialManagementRoutes
